import { Navigate } from 'react-router-dom';

import { cookieService } from '~/services/cookie-service';

const GuestRoute = ({ children }: { children: JSX.Element }) => {
  const isAuthenticated = cookieService.getCookie('access') || null;

  if (isAuthenticated) {
    return <Navigate to="/app/my_qr" replace />;
  }

  return children;
};

export default GuestRoute;
